export enum McaDocumentType {
    MEDICAL_CERTIFICATE = 'MEDICAL_CERTIFICATE',
    MEDICAL_CERTIFICATE_DRIVER = 'MEDICAL_CERTIFICATE_DRIVER',
    MEDICAL_CERTIFICATE_DRIVER_SPECIAL = 'MEDICAL_CERTIFICATE_DRIVER_SPECIAL',
    MEDICAL_CERTIFICATE_WEAPON = 'MEDICAL_CERTIFICATE_WEAPON',
    MEDICAL_REPORT = 'MEDICAL_REPORT',
    OTHER = 'OTHER',
    STRUCTURED = 'STRUCTURED',
    CUSTOMER_DOCUMENT = 'CUSTOMER_DOCUMENT',
}
